import 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { jsxs, jsx } from 'react/jsx-runtime';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var classNamePrefix = 'forno-card';
var statuses = ['enabled', 'disabled'];
var themes = ['light'
/* , 'dark' */
];

function Content(_ref) {
  var name = _ref.name,
      children = _ref.children;
  return /*#__PURE__*/jsxs("footer", {
    className: "".concat(classNamePrefix, "-content"),
    children: [name && /*#__PURE__*/jsx("h3", {
      className: "".concat(classNamePrefix, "-content-title"),
      children: name
    }), /*#__PURE__*/jsx("div", {
      className: "".concat(classNamePrefix, "-content-wrapper"),
      children: children
    })]
  });
}

Content.propTypes = {
  children: PropTypes.node,
  name: PropTypes.string
};
Content.defaultProps = {
  children: null,
  name: null
};

function CardPreview(_ref) {
  var preview = _ref.preview,
      name = _ref.name,
      placeholderIcon = _ref.placeholderIcon;
  return /*#__PURE__*/jsx("section", {
    className: "".concat(classNamePrefix, "-preview-wrapper"),
    children: preview ? /*#__PURE__*/jsx("img", {
      src: preview,
      alt: name,
      className: "".concat(classNamePrefix, "-preview")
    }) : /*#__PURE__*/jsx("div", {
      className: "".concat(classNamePrefix, "-preview-placeholder"),
      icon: placeholderIcon,
      children: placeholderIcon
    })
  });
}

CardPreview.propTypes = {
  preview: PropTypes.string,
  name: PropTypes.string,
  placeholderIcon: PropTypes.node
};
CardPreview.defaultProps = {
  preview: null,
  name: '',
  placeholderIcon: null
};

var _excluded = ["name", "theme", "status", "url", "content", "preview", "children", "placeholderIcon", "actions"];

function Card(_ref) {
  var name = _ref.name,
      theme = _ref.theme,
      status = _ref.status,
      url = _ref.url;
      _ref.content;
      var preview = _ref.preview,
      children = _ref.children,
      placeholderIcon = _ref.placeholderIcon,
      actions = _ref.actions,
      rest = _objectWithoutProperties(_ref, _excluded);

  var customClass = classNames('card', classNamePrefix);
  return /*#__PURE__*/jsxs("article", _objectSpread2(_objectSpread2({
    "data-testid": "Card",
    className: "".concat(classNamePrefix, "-wrapper"),
    "data-status": status
  }, rest), {}, {
    children: [/*#__PURE__*/jsxs("a", {
      href: url,
      className: customClass,
      "data-theme": theme,
      children: [/*#__PURE__*/jsx(CardPreview, {
        preview: preview,
        name: name,
        placeholderIcon: placeholderIcon
      }), /*#__PURE__*/jsx(Content, {
        name: name,
        url: url,
        children: children
      })]
    }), /*#__PURE__*/jsx("div", {
      className: "".concat(classNamePrefix, "-children"),
      "data-testid": "Menu-container",
      children: actions
    })]
  }));
}
Card.propTypes = {
  name: PropTypes.string,
  theme: PropTypes.oneOf(themes),
  status: PropTypes.oneOf(statuses),
  url: PropTypes.string,
  preview: PropTypes.string,
  content: PropTypes.node,
  children: PropTypes.node,
  placeholderIcon: PropTypes.node,
  actions: PropTypes.node
};
Card.defaultProps = {
  name: '',
  status: 'enabled',
  theme: 'light',
  url: null,
  preview: null,
  content: null,
  children: null,
  placeholderIcon: null,
  actions: null
};

export { Card as default };
